import {
  HIDE_WELCOME_SCREEN,
  LOGIN,
  LOGIN_REQUEST,
  LOGOUT,
  SAVE_PURCHASE_STATUS,
  SHOW_WELCOME_SCREEN,
  START_LOADING,
  STOP_LOADING,
  UPDATE_ACHIEVEMENT_DETAILS,
} from './ActionTypes';

export const LoginRequest = (loginBody, callback) => {
  return {
    type: LOGIN_REQUEST,
    loginBody: loginBody,
    callback: callback,
  };
};

export const Login = (userId, emailId, sessionToken) => {
  return {
    type: LOGIN,
    userId: userId,
    emailId: emailId,
    sessionToken: sessionToken,
    unlockedAchievementArray: [false, false, false, false, false, false, false],
  };
};

export const setPurchaseStatus = purchaseStatus => {
  return {
    type: SAVE_PURCHASE_STATUS,
    purchaseStatus: purchaseStatus,
  };
};

export const Logout = () => {
  return {
    type: LOGOUT,
    userId: 0,
    emailId: '',
    sessionToken: '',
  };
};

export const updateAchievementDetails = () => {
  return {
    type: UPDATE_ACHIEVEMENT_DETAILS,
  };
};

export const startLoading = () => {
  return {
    type: START_LOADING,
  };
};

export const stopLoading = () => {
  return {
    type: STOP_LOADING,
  };
};

/******* show welcome message *********/
export const showWelcomeScreen = () => {
  return {
    type: SHOW_WELCOME_SCREEN,
  };
};

export const hideWelcomeScreen = () => {
  return {
    type: HIDE_WELCOME_SCREEN,
  };
};
/**************************************/
